import { signal } from "@preact/signals-react";
import { logToken } from "./login.signal";

export const offerData = signal(null);
export const searchClientData = signal(null);
export const editOfferData = signal(null);

export async function fetchShowingOffer() {
  const url = "https://alguthmi.co/API/B2BAppAPI/fetchOffer.php";
  const bearerToken = logToken.value;
  const options = {
    method: "POST",
    headers: {
      Authorization: `Bearer ${bearerToken}`,
      origin: "http://alguthmi.co",
    },
    body: JSON.stringify({}),
  };

  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      throw new Error("Network response was not ok");
    }

    const data = await response.json();
    return data;
  } catch (error) {
    console.error("Error:", error);
  }
}
